import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TeamShiftLookupComponent } from './team-shift-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [TeamShiftLookupComponent],
  exports: [TeamShiftLookupComponent],
  providers: []
})
export class TeamShiftLookupModule { }
